import { Button, PhoneFilledIcon, Tooltip } from '@calizahq/react-components-v2'
import { WorkspaceView } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import { BookablePerson } from '@sales-app/types/BookablePerson'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as FlagIcon } from '@/assets/icons/flag.svg'

export const UsersListColumns = [
  {
    Header: 'Name',
    accessor: 'fullName',
    width: 100,
    Cell: function Cell({ row }: { row: { original: BookablePerson } }) {
      return (
        <div className="flex items-center justify-center">
          <h3 className="font-bold">{row.original.fullName}</h3>
          {row.original.hasDuplicates && <FlagIcon className="ml-2 text-red-300" />}
        </div>
      )
    },
  },
  {
    Header: 'Email',
    accessor: 'email',
    width: 100,
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    width: 100,
    Cell: ({ value }: { value: string }) => {
      return (
        <div className="flex underline mr-8">
          {value ? (
            <a href={`dialpad://${value}`} rel="noreferrer" target="_blank">
              <div className="flex flex-row">
                <div>
                  <Tooltip text="Call with Dialpad">
                    <PhoneFilledIcon className="w-6 mr-2" height={28} width={28} />
                  </Tooltip>
                </div>
                <div className="mt-1">{value}</div>
              </div>
            </a>
          ) : null}
        </div>
      )
    },
  },
  {
    Header: 'Type',
    accessor: 'bookablePersonType',
    width: 50,
  },
  {
    accessor: 'bookablePersonId',
    width: 120,
    maxWidth: 120,
    canResize: false,
    Cell: function Cell({ row }: { row: { original: BookablePerson } }) {
      const navigate = useNavigate()
      const { bookablePersonId, bookablePersonType } = row.original
      const openWorkspace = () => {
        const path = getWorkspacePath({
          view: WorkspaceView.SUMMARY,
          type: bookablePersonType,
          id: bookablePersonId,
          potentialBookingId: null,
        })

        navigate(path)
      }
      return (
        <div className="ml-auto flex items-center justify-center">
          <Button className=" bg-text-semantic-success" onClick={openWorkspace} size="small">
            View
          </Button>
        </div>
      )
    },
  },
]
